var map = {
	"./Slide000.avif": 6327,
	"./Slide001.avif": 6753,
	"./Slide002.avif": 1173,
	"./Slide01.webp": 9566,
	"./Slide02.webp": 7103,
	"./Slide03.webp": 2407,
	"./Slide04.webp": 9261,
	"./Slide05.webp": 6839,
	"./Slide06.webp": 5391,
	"./Slide07.webp": 9466,
	"./Slide08.webp": 2432,
	"./Slide09.webp": 4234,
	"./Slide10.webp": 7134,
	"./Slide11.webp": 9556,
	"./Slide12.webp": 8436,
	"./Slide13.webp": 9368,
	"./Slide14.webp": 9233,
	"./Slide15.webp": 4593,
	"./Slide16.webp": 3378,
	"./Slide17.webp": 5857,
	"./Slide18.webp": 7996,
	"./Slide19.webp": 742,
	"./Slide20.webp": 2725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1883;